import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import {
  AdminCopy,
  AdminHeader,
  AdminTitle,
  AdminTrash,
  AdminViewIntegrations,
} from 'components/admin/lib/admin_layout';
import ApiToken from 'models/api_token';
import ApiTokenNameContainer from './api_token_name';
import Button, { ButtonTypes } from 'components/common/button';
import Col from 'components/common/grid/col';
import connect from 'components/lib/connect';
import copyTextToClipboard from 'components/lib/copy_text_to_clipboard';
import CreateApiToken from 'actions/api_tokens/create_api_token';
import Grid from 'components/common/grid/grid';
import LongDateTime from 'components/lib/date/long_date_time';
import RemoveApiToken from 'actions/api_tokens/remove_api_token';
import Row from 'components/common/grid/row';

export function ApiTokenList({ apiTokens, isAddPending, onClickCopy, onClickNew, onClickRemove }) {
  return (
    <AdminViewIntegrations className="apiTokens">
      <AdminHeader className="apiTokens-header">
        <AdminTitle>API Tokens</AdminTitle>
        <Button
          className="apiTokens-list-addToken"
          onClick={onClickNew}
          buttonType={ButtonTypes.SECONDARY}
          disabled={isAddPending}
          data-aid="apiTokens-addToken"
        >
          Add Token
        </Button>
      </AdminHeader>
      <div className="apiTokens-list">
        <Grid>
          {renderCopyPrompt()}
          <Row className="apiTokens-list-header">
            <Col colSpan="3">Name</Col>
            <Col colSpan="4">Token</Col>
            <Col colSpan="2">Last Used</Col>
          </Row>
        </Grid>
        {apiTokens.map(renderApiTokenRow)}
      </div>
    </AdminViewIntegrations>
  );

  function renderCopyPrompt() {
    if (!_.some(apiTokens, apiToken => apiToken.token)) {
      return null;
    }

    return (
      <Row>
        <Col className="apiTokens-list-copyPrompt">
          Get a token to integrate with our API.
          <br />
          Copy and save your token in a safe place. You will only see the token once.
        </Col>
      </Row>
    );
  }

  function renderApiTokenRow(apiToken) {
    return (
      <Row className="apiTokens-list-row" key={apiToken.id}>
        <Col className="apiTokens-list-col-name" colSpan="3">
          <ApiTokenNameContainer id={apiToken.id} value={apiToken.name} />
        </Col>
        <Col colSpan="4">{apiToken.token || '************************'}</Col>
        <Col colSpan="2">{apiToken.lastUsedAt ? <LongDateTime timestamp={apiToken.lastUsedAt} /> : '———'}</Col>
        <Col />
        <Col className="apiTokens-list-col-controls" colSpan="2">
          {apiToken.token && (
            <AdminCopy className="apiTokens-list-copyToken" onClick={() => onClickCopy(apiToken.token)} />
          )}
          <AdminTrash className="apiTokens-list-removeToken" onClick={() => onClickRemove(apiToken.id)} />
        </Col>
      </Row>
    );
  }
}

ApiTokenList.propTypes = {
  apiTokens: PropTypes.arrayOf(PropTypes.instanceOf(ApiToken)).isRequired,
  isAddPending: PropTypes.bool,
  onClickCopy: PropTypes.func.isRequired,
  onClickNew: PropTypes.func.isRequired,
  onClickRemove: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapExecuteToProps)(ApiTokenList);

function mapStateToProps({ getProvider }) {
  let apiTokensProvider = getProvider('apiTokens');

  return {
    apiTokens: apiTokensProvider.findAll(),
    isAddPending: apiTokensProvider.isPendingNew(),
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onClickCopy: token => copyTextToClipboard(token),
    onClickNew: () => executeAction(CreateApiToken),
    onClickRemove: id => executeAction(RemoveApiToken, id),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/api_tokens/api_token_list.jsx